









































































































import { Component, Vue, Prop } from 'vue-property-decorator';
import * as Common from '@/agiles/common';
import * as Components from '@/agiles/components';

@Component
export default class ReportTemplateVue extends Vue {
  public items: Common.ReportTemplate[] = new Array();
  public params: Common.ReportTemplateQuery = new Common.ReportTemplateQuery();
  public approvalStates = Common.ApprovalStatus;
  public langEnabled : boolean = false;
  public previewItem: Common.ReportTemplate = null;
  public previewVoucherNo:any = null;
  @Prop() public id:number;
  @Prop({default:null}) public popup: Components.PopupEditor;

  public created(){
    if(this.id) this.params.id = this.id;
    this.params.state = null;
    // ライセンスによって表示項目を制御する
    this.langEnabled  = this.$api.hasLicense(Common.licenseFlags.currency);
  }
  public sortOptions: any = [
    { value: 'State', text: '状態' },
    { value: 'viewName', text: '表示画面' },
    { value: 'reportName', text: '帳票名' },
  ];
  showUpload: boolean = false;
  uploadFileValidation: string = null;

  public tabs(obj: Common.ReportTemplate) {
    return obj != null && obj.controller && obj.controller.supportMail  ? ['基本情報','メール設定'] :['基本情報']
  }
  public  tabVisibles(obj: Common.ReportTemplate){
    // if (!this.$refs.mainList) return [true,false]; //フォールバック。エラー放置すると$refsへの反映が遅延してしまう
    // const obj = (this.$refs.mainList as Components.ListView).selected as Common.ReportTemplate;
    return obj != null && obj.controller && obj.controller.supportMail ?  [true,true] :[true,false];
  }
  public onMoveToLayouts() {
    const obj = (this.$refs.mainList as Components.ListView).selected as Common.ReportTemplate;
    this.$router.push('/system/ReportLayout?templateId=' + obj.id);
  }

  onCustomPaperSizeChanged() { 
    const obj = (this.$refs.mainList as Components.ListView).selected as Common.ReportTemplate;
    if(obj.useCustomPaperSize==false){
      obj.customPaperSizeWidth=0;
      obj.customPaperSizeHeight=0;
    }
  }
  public onUploadFile() {
    this.showUpload = true;
  }

  public showPreviewDialog(item: Common.ReportTemplate){
    if(this.previewItem != item){
      this.previewItem = item;
      this.previewVoucherNo = null;
    }
    (this.$refs.reportPreview as Components.ListDialog).showDialog();
  }

  public onDownload(templateId: number) {
    if (templateId == 0) return;
    const query = new Common.ReportTemplateDownloadQuery(templateId);
    this.$api.download(query);
  }
  public onInput() {
    const obj = (this.$refs.file as any).files as FileList;
    if (obj.length == 0) {
      this.uploadFileValidation = 'ファイルを選択してください。';
    } else if (obj[0].name.length > 50) {
      this.uploadFileValidation = '登録可能なファイル名は最大50桁です。';
    } else {
      this.uploadFileValidation = null;
    }
  }
  public onAdd(args: any) {
    const obj = (this.$refs.file as any).files as FileList;
    if (obj.length == 0) {
      this.uploadFileValidation = 'ファイルを選択してください。';
      args.preventDefault();
      return;
    } else if (obj[0].name.length > 50) {
      this.uploadFileValidation = '登録可能なファイル名は最大50桁です。';
      args.preventDefault();
      return;
    } else {
      this.uploadFileValidation = null;
    }

    const query = new Common.ReportTemplateUploadQuery();
    query.templateId = (this.$refs.mainList as Components.ListView).selected.id;
    query.timestamp = new Date(obj[0].lastModified).toISOString();

    var selectedId = (this.$refs.mainList as Components.ListView).selectedId();
    this.$api.upload(query, obj).then(response => {
      this.$set(this.items, selectedId, response);
    });
  }

  public onResetSystemTemplate() {
    this.$api.modal.showDialog('確認メッセージ','システム帳票を全て削除し、最新バージョンで初期化します。よろしいですか？',false).then(()=>{
      this.$api.execute(new Common.ReportTemplateResetQuery()).then(res =>{
        var links = [new Common.ModalLink(String.format('システムログ ID={0}',res),String.format('/operation/SystemLog?id={0}',res))];
        this.$api.modal.show('処理結果','初期化処理が開始されました。\r\n実行結果は、以下のリンクから確認できます。',true,null,links);          
      });
    });
  }  
  public onWorkflow(index: number, obj: any) {
    this.$set(this.items, index, obj);
  }    

  public onSelected(index: number, item: Common.ReportTemplate) {
    item.isSentFromClient = true; // ユーザー側からのデータの送信の際はユーザー帳票に変えるためのフラグ
  }
  public async cmbPreviewVoucherNoQuery():Promise<Common.BindItem[]> {
    var bindItems = new Array();
    var query = new Common.PreviewVoucherNoQuery(this.previewItem.viewName);
    await this.$api.execute(query).then(res => {
        var result = res as Common.LoadResult;
        result.result.forEach(obj =>{
          bindItems.push(new Common.BindItem(obj.value,obj.name));
        });
      });
    return Promise.resolve(bindItems);
  }
  public async onReportGenerate() {
    let template = (this.$refs.mainList as Components.ListView).selected as Common.ReportTemplate;
    let viewname = '';
    let key = null;
    key = this.previewVoucherNo;
    switch(template.viewName){
      case "menu_purchase_order" : 
      case "menu_sales_order" : 
        viewname='Order';
        break;
      case "menu_purchase_delivery" : 
      case "menu_sales_delivery" : 
        viewname='Delivery';
        break;
      case "menu_invoice" : 
        viewname='Invoice';
        key = Number(this.previewVoucherNo);
        break;
      case "menu_purchase_charge" : 
      case "menu_sales_charge" : 
        viewname='Charge';
        break;
      case "menu_receive_payment" : 
      case "menu_send_payment" : 
        viewname='Payment';
        break;
      case "menu_picking" : 
        viewname='Picking';
        break;
      case "menu_stock_balance" : 
        viewname='StockBalance';
        break;
      case "menu_stock_relocation" : 
        viewname='StockRelocation';
        break;
      case "menu_stock_taking" : 
        viewname='StockTaking';
        break;
      case "menu_stock_transfer" : 
        viewname='StockTransfer';
        break;
      case "menu_project_item" : 
        viewname='ProjectItem';
        break;
    }
    this.$api.find(viewname, [key]).then(res => {
      var query = new Common.ReportQuery2(template.queryName, [res]);
      query.templateId = template.id;
      query.onExcelFormat = false;
      this.$api.download(query);
    });
  }
}

